// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: tools/lcmtype_auto_translation/lcmtypes/common.legacy_255861669266133548_flight_phase_t.lcm

import { int64_t } from "@skydio/lcm/src/types";
import { fault_t } from "../common/fault_t";
import { flight_phase_enum_t } from "../common/flight_phase_enum_t";
import { flight_phase_transition_t } from "../common/flight_phase_transition_t";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class legacy_255861669266133548_flight_phase_t extends LcmMsg {

  private static _hash = Long.fromString("1918188395778962825", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (legacy_255861669266133548_flight_phase_t._packed_fingerprint === undefined) {
      legacy_255861669266133548_flight_phase_t._packed_fingerprint = legacy_255861669266133548_flight_phase_t._get_hash_recursive([]);
    }
    return legacy_255861669266133548_flight_phase_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(legacy_255861669266133548_flight_phase_t) > -1) {
      return Long.fromNumber(0, true);
    }
    const new_parents = parents.concat([legacy_255861669266133548_flight_phase_t]);
    let tmp_hash = legacy_255861669266133548_flight_phase_t._hash;
    tmp_hash = tmp_hash.add(flight_phase_enum_t._get_hash_recursive(new_parents));
    tmp_hash = tmp_hash.add(flight_phase_transition_t._get_hash_recursive(new_parents));
    tmp_hash = tmp_hash.add(fault_t._get_hash_recursive(new_parents));
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    transition_nonce: { kind: "primitive", type: Number, typeStr: "int64_t" },
    phase_id: { kind: "struct", type: flight_phase_enum_t, typeStr: "flight_phase_enum_t" },
    flight_id: { kind: "primitive", type: String, typeStr: "string" },
    transition_reason: { kind: "struct", type: flight_phase_transition_t, typeStr: "flight_phase_transition_t" },
    faults: { kind: "array", dims: [{ kind: "auto" }], nDim: 1, inner: { kind: "struct", type: fault_t, typeStr: "fault_t" } },
    is_manual_mode: { kind: "primitive", type: Boolean, typeStr: "boolean" },
  };

  public utime: int64_t;
  public transition_nonce: int64_t;
  public phase_id: flight_phase_enum_t;
  public flight_id: string;
  public transition_reason: flight_phase_transition_t;
  public faults: fault_t[];
  public is_manual_mode: boolean;

  public override decode(byte_array: Uint8Array): legacy_255861669266133548_flight_phase_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(legacy_255861669266133548_flight_phase_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, legacy_255861669266133548_flight_phase_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): legacy_255861669266133548_flight_phase_t {
    this.utime = decoder.decode_int64_t();
    this.transition_nonce = decoder.decode_int64_t();
    this.phase_id = new flight_phase_enum_t().decode_one(decoder);
    this.flight_id = decoder.decode_string();
    this.transition_reason = new flight_phase_transition_t().decode_one(decoder);
    const v_num_faults = decoder.decode_int32_t();
    this.faults = new Array(v_num_faults);
    for (let i0 = 0; i0 < v_num_faults; i0++) {
      this.faults[i0]! = new fault_t().decode_one(decoder);
    }
    this.is_manual_mode = decoder.decode_boolean();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8;
    total_size += 8;
    total_size += this.phase_id._get_encoded_size();
    total_size += 4 + new TextEncoder().encode(this.flight_id).length + 1;
    total_size += this.transition_reason._get_encoded_size();
    const v_num_faults = this.faults.length;
    total_size += 4;
    for (let i0 = 0; i0 < v_num_faults; i0++) {
      total_size += this.faults[i0]!._get_encoded_size();
    }
    total_size += 1;
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(legacy_255861669266133548_flight_phase_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int64_t(this.utime);
    encoder.encode_int64_t(this.transition_nonce);
    this.phase_id.encode_one(encoder);
    encoder.encode_string(this.flight_id);
    this.transition_reason.encode_one(encoder);
    const v_num_faults = this.faults.length;
    encoder.encode_int32_t(v_num_faults);
    for (let i0 = 0; i0 < v_num_faults; i0++) {
      this.faults[i0]!.encode_one(encoder);
    }
    encoder.encode_boolean(this.is_manual_mode);
  }

  constructor(init?: {utime?: int64_t, transition_nonce?: int64_t, phase_id?: flight_phase_enum_t, flight_id?: string, transition_reason?: flight_phase_transition_t, faults?: fault_t[], is_manual_mode?: boolean }) {
    super();
    this.utime = 0;
    this.transition_nonce = 0;
    this.phase_id = new flight_phase_enum_t();
    this.flight_id = "";
    this.transition_reason = new flight_phase_transition_t();
    this.faults = [];
    this.is_manual_mode = false;

    // optionally override default values
    if (!init) {
      return;
    }
    this.utime = init.utime || this.utime;
    this.transition_nonce = init.transition_nonce || this.transition_nonce;
    this.phase_id = init.phase_id || this.phase_id;
    this.flight_id = init.flight_id || this.flight_id;
    this.transition_reason = init.transition_reason || this.transition_reason;
    this.faults = init.faults || this.faults;
    this.is_manual_mode = init.is_manual_mode || this.is_manual_mode;
  }
}